<script>
  import {Bar, mixins} from 'vue-chartjs'

  export default {
    extends: Bar,
    name: 'stats-bar-chart',
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    data () {
      return {
        options: {
          scales: {
            yAxes: [{
              barPercentage: 0.5,
              gridLines: {
                display: true
              }
            }],
            xAxes: [{
              gridLines: {
                barPercentage: 0.5,
                zeroLineColor: 'black',
                zeroLineWidth: 2
              },
              ticks: {
                min: 1,
                max: 12,
                stepSize: 1
              },
              scaleLabel: {
                display: true
                // labelString: "Density in kg/m3"
              }
            }]
          },
          elements: {
            rectangle: {
              borderSkipped: 'left'
            }
          }
        }
      }
    },
    mounted () {
      // Overwriting base render method with actual data.
      /* this.chartData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: 'Population (millions)',
            backgroundColor: [
              '#3e95cd', '#8e5ea2', '#3cba9f', '#e8c3b9', '#c45850'],
            data: [2478, 5267, 734, 784, 433]
          }
        ]
      } */
      this.renderChart(this.chartData, this.options)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StatsBarChart.vue